// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { deleteRelatedLine as deleteRelatedLineApi, DeleteRelatedLine } from "@bg/App/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadQuote from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";

interface Props {
    apiParameter: DeleteRelatedLine;
    apiResult: { successful: boolean; error?: any };
}

type Parameter = DeleteRelatedLine & {
    reloadQuote?: boolean;
    onComplete?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginAction: HandlerType = props => {
    props.dispatch({
        type: "Data/Quotes/BeginLoadQuote",
        quoteId: props.parameter.cartId,
    });
    props.apiParameter = {
        cartId: props.parameter.cartId,
        originalGroupName: props.parameter.originalGroupName,
        linesModel: props.parameter.linesModel,
    };
};
let counter = 0;
export const CallApiWithParameters: HandlerType = async props => {
    counter++;
    props.apiResult = await deleteRelatedLineApi(props.apiParameter);
    counter--;
};

export const ReloadQuoteOnSuccess: HandlerType = props => {
    if (counter === 0 && props.apiResult.successful && props.parameter.reloadQuote) {
        props.dispatch(loadQuote({ quoteId: props.parameter.cartId }));
    }
};

export const CallOnComplete: HandlerType = props => {
    if (counter === 0 && props.apiResult.successful && props.parameter.onComplete) {
        props.parameter.onComplete(props.apiResult);
    }
};

export const chain = [DispatchBeginAction, CallApiWithParameters, ReloadQuoteOnSuccess, CallOnComplete];

const deleteRelatedLine = createHandlerChainRunner(chain, "DeleteRelatedLine");
export default deleteRelatedLine;
